import { useCallback, useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useTab } from '../contexts/TabContext';
import { usePrizeExpansion } from '../contexts/PrizeExpansionContext';
import { TabValue } from '../constants/prize';
import { selectAccountInfo } from '../selectors/account.selector';
import { findFirstPrizeWithTaxInterviewUrl } from '../utils/prizeAgeUtils';

export const useRetakePrizeNavigation = () => {
    const history = useHistory();
    const { setCurrentTab } = useTab();
    const { sortedPrizes } = usePrizeExpansion();
    const accountInfo = useSelector(selectAccountInfo);

    const firstPrizeWithTaxInterviewUrl = useMemo(
        () => findFirstPrizeWithTaxInterviewUrl(sortedPrizes, accountInfo),
        [sortedPrizes, accountInfo]
    );

    const handleRetakeButtonClick = useCallback(() => {
        if (firstPrizeWithTaxInterviewUrl) {
            setCurrentTab(TabValue.PRIZES);
            // Navigate to prize detail page instead of default expanding
            history.push(
                `${window.appContext}/v2/prize-detail?prizeId=${firstPrizeWithTaxInterviewUrl.prizeId}`
            );
            return true;
        }
        return false;
    }, [firstPrizeWithTaxInterviewUrl, setCurrentTab, history]);

    return {
        firstPrizeWithTaxInterviewUrl,
        handleRetakeButtonClick
    };
};
